<?xml version="1.0" encoding="UTF-8"?>
<svg width="256px" height="256px" viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>icon-italic-complete</title>
    <g id="icon-italic-complete" stroke="none" stroke-width="1"  fill-rule="evenodd">
        <polygon id="I" fill-rule="nonzero" points="141.0907 256 172.399 -1.13686838e-13 114.7073 -1.13686838e-13 83.399 256"></polygon>
    </g>
</svg>